import styled from "styled-components"
import { T } from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import { FadeIn, FadeInBottom } from "../shared/keyframes.style"

export const ContentWrapper = styled.div`
  margin-top: 24px;
  .location-data {
    grid-row: 1;
  }
  .geometry {
    grid-row: 3;
  }
  .draft-publish {
    grid-row: 5;
  }

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 64px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 100px;
    .location-data {
      grid-row: 1;
    }
    .geometry {
      grid-row: 2;
    }
    .draft-publish {
      grid-row: 3;
    }
  }
`

export const StyledImage = styled.img`
  display: flex;
  width: 100%;
  height: auto;
  align-self: center;
  grid-column: 1 / -1;
  margin-bottom: 48px;

  :nth-child(4) {
    grid-row: 3;
  }

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 4 / -4;
    margin-bottom: 48px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: ${props => props.desktopGrid};
    margin-bottom: 128px;
    :nth-child(4) {
      grid-row: unset;
    }
  }

  animation: ${props => !props.disableAnimations && FadeIn};
  animation-play-state: ${props => (props.isVisible ? "running" : "paused")};

  animation-duration: 1s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-fill-mode: both;
`

export const TitleText = styled.h3`
  ${T.sm.h3.bold}
  @media (min-width: ${Breakpoints.md}) {
    ${T.md.h3.bold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h3.semiBold}
  }
  
  color: var(--slate);
`

export const BodyText = styled.p`

  ${T.sm.body.regular}

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body.regular}
  }

  
  color: var(--body-text-grey);
  margin-top: 24px;
`

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 64px;
  grid-column: 2 / -2;

  @media (min-width: ${Breakpoints.md}) {
    align-items: center;
    text-align: center;
    margin-bottom: 96px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    align-items: flex-start;
    text-align: left;
    grid-column: ${props => props.desktopGrid};
    margin-bottom: 128px;
  }

  ${TitleText} {
    animation: ${props => !props.disableAnimations && FadeIn};
    animation-play-state: ${props => (props.isVisible ? "running" : "paused")};

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0.4s;
    animation-fill-mode: both;
  }

  ${BodyText} {
    animation: ${props => !props.disableAnimations && FadeInBottom};
    animation-play-state: ${props => (props.isVisible ? "running" : "paused")};

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0.8s;
    animation-fill-mode: both;
  }
`

export const LineDivider = styled.div`
  height: 1px;
  background-color: var(--dark-mode-heading);
  grid-column: 2 / -2;
`
